import classNames from "classnames";
import React from "react";
import PropTypes from "prop-types";

// Deprecated! Use common/DS/Buttons!
export const Button = ({
    children,
    className,
    disabled,
    large,
    loading,
    onClick,
    primary,
    navy,
    red,
    reversed,
    secondary,
    small,
    submit,
    violet,
    white,
    ref,
}) => (
    <button
        className={classNames(
            "btn",
            {
                loading,
                "btn-primary": primary,
                "btn-secondary": secondary,
                "btn--navy": navy,
                "btn--red": red,
                "btn--violet": violet,
                "btn--white": white,
                "btn--reversed": reversed,
                "btn-large": large,
                "btn-small": small,
            },
            className,
        )}
        disabled={disabled || loading}
        onClick={onClick}
        type={submit ? "submit" : "button"}
        ref={ref}
    >
        {children}
    </button>
);

Button.propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    large: PropTypes.bool,
    loading: PropTypes.bool,
    onClick: PropTypes.func,
    primary: PropTypes.bool,
    navy: PropTypes.bool,
    red: PropTypes.bool,
    reversed: PropTypes.bool,
    secondary: PropTypes.bool,
    small: PropTypes.bool,
    submit: PropTypes.bool,
    violet: PropTypes.bool,
    white: PropTypes.bool,
    ref: PropTypes.any,
};

Button.defaultProps = {
    className: null,
    disabled: false,
    large: false,
    loading: false,
    onClick: null,
    primary: false,
    navy: false,
    red: false,
    reversed: false,
    secondary: false,
    small: false,
    submit: false,
    violet: false,
    white: false,
    ref: null,
};
